<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasMessageArchive" 
         aria-labelledby="offcanvasMessageArchiveLabel"
         @blur="focusOff()"
      >
      <!--
         @blur="focusOff()"
      -->
      <div class="offcanvas-header">
         <!-- <h6 id="offcanvasMessageArchiveLabel">{{messageArchiveTxt == "MSG" ? '¿Desea enviar esta Tarjeta a Comunicaciones?' : '¿Desea Archivar esta Tarjeta?'}}</h6> -->
         <h6 id="offcanvasMessageArchiveLabel">{{".MSG.UAR.".indexOf( messageArchiveTxt ) > -1  ? '¿Desea enviar esta Tarjeta a Comunicaciones?' : '¿Desea Archivar esta Tarjeta?'}}</h6>
         <button type="button" 
            id="btn_close_offcanvas"
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="messageArchiveExit"
         ></button>
      </div>
      <!--
      <hr class="m-0"/>
      {{cellId}} - {{contentId}}
         <div>{{boardCellTo}}</div>
      -->
      <hr class="m-0"/>
      <div class="offcanvas-body text-center">
         <p v-if="'.MSG.UAR.'.indexOf( messageArchiveTxt ) > -1">Esta operación MOVERA esta tarjeta al área de Comunicaciones.</p>
         <!--
         <p v-if="messageArchiveTxt == 'MSG'">Esta operación MOVERA esta tarjeta al área de Comunicaciones.</p>
         <p v-else>Esta operación MOVERA DE FORMA PERMANENTE esta tarjeta al Archivo.</p>
         -->
         <p v-else>Esta operación MOVERA esta tarjeta al Archivo.</p>
         <div class="row px-1 pt-2 gap-1">
            <div v-if="!moving">
               <!-- <div v-if="messageArchiveTxt == 'MSG'" class="fp-onOff btn-danger rounded" @click="messageArchive()"> -->
               <div v-if="'.MSG.UAR.'.indexOf( messageArchiveTxt ) > -1" class="fp-onOff btn-danger rounded" @click="messageArchive()">
                  Enviar a Comunicaciones
               </div>
               <div v-else class="fp-onOff btn-danger rounded" @click="messageArchive()">
                  Archivar
               </div>
            </div>
            <div v-else>
               <div class="fp-onOff btn-danger rounded" >
                  <span class="spinner-border spinner-border-sm"></span>
                  {{txtMoving}}
               </div>
            </div>
         </div>
      </div>
   </div>
   </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

export default {
   
   components: {
   },
   
   setup() {
      const store = useStore()

      const boardId = ref(null)
      const cellId = ref(0)
      const contentId = ref(0)
      const messageArchiveExit = ref(null)
      const messageArchiveTxt = ref("xxx")
      const cardTypeId = ref(0)
      const boardCellTo = ref({})

      const moving = ref(false)
      const txtMoving = ref('')
      const message = ref({})

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasMessageArchive')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            contentId.value = button.getAttribute('data-content-id')
            messageArchiveTxt.value = button.getAttribute('data-message-archive')
            cardTypeId.value = button.getAttribute('data-card-type-id')
            boardId.value = WspService.getBoardId(store)
            boardCellTo.value = {}
            moving.value = false
            message.value = {}
            myOffCanvas.focus()
            console.log("show MessageArchive OC")
         })
      })

      function messageArchive() {
         moving.value = true
         //if ( messageArchiveTxt.value == 'MSG' ) {
         if ( '.MSG.UAR.'.indexOf( messageArchiveTxt.value ) -1 ) {
            txtMoving.value = 'Enviando'
         }
         if ( messageArchiveTxt.value == 'ARC' ) {
            txtMoving.value = 'Archivando'
         }
         WspService.getBoardsTo(
            boardId.value, 
            cardTypeId.value, 
            contentId.value, 
            messageArchiveTxt.value)      // "ARC" )
         .then(response => {
            boardCellTo.value = response.data[0]
            console.log(response.data)
            WspService.addAuditMoveOrShared(
                  contentId.value, 
                  "RMV", 
                  store.state.auth.user.id, 
                  null,
                  cellId.value,
                  boardId.value,
                  boardCellTo.value.id,
                  boardCellTo.value.cellsTo[0].cellLabelId,
                  messageArchiveTxt.value
                  )
            .then(response => {
               //store.dispatch("wspace/setContentId", -8)
               //setTimeout( setStore, 6000, -8 )
               console.log("MessageArchive: "+response.data)
               message.value = response.data
               if ( message.value.statusCode == 0 ) {
                  setTimeout( setStore, 6000, -8 )
               } else {
                  alert( message.value.message )
                  setTimeout( setStore, 2000, -8 )
               }
            })
         .catch(error => {
            console.log(error);
         });
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function setStore( negativeId ) {
         store.dispatch( "wspace/setContentId", negativeId )
         messageArchiveExit.value.click
      }
      
      function focusOff() {
         //
         if ( messageArchiveExit.value != null ) {
            messageArchiveExit.value.click()
         }
         //
      }

      return {
         boardId, boardCellTo,
         cellId,
         cardTypeId,
         contentId,
         focusOff,
         messageArchive, messageArchiveExit, messageArchiveTxt, message,
         moving, txtMoving
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 25px;
  right: 100px;
  width: 390px;
  height: fit-content;
}
/*
   width: max-content;
   width: 170px;
*/
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-save {
   opacity: .7;
   background-color: blue;
   color: white;
}
.btn-save:hover {
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.fp-onOff {
  width: 363px;
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.fs-11 {
   font-size: 11px;
}
</style>